/**
 * User settings operations — get, update.
 */

import type { ArbiClient, components } from '@arbidocs/client'
import { requireData, requireOk } from '../errors.js'

type UserSettingsUpdate = components['schemas']['UserSettingsUpdate']

export async function getSettings(arbi: ArbiClient) {
  return requireData(await arbi.fetch.GET('/v1/user/settings'), 'Failed to fetch settings')
}

export async function updateSettings(arbi: ArbiClient, body: UserSettingsUpdate) {
  requireOk(await arbi.fetch.PATCH('/v1/user/settings', { body }), 'Failed to update settings')
}
